<template>
  <div>
    <div>
      <el-row>
        <!-- 工具条 -->
        <el-form
          :inline="true"
          :model="formInline"
          class="demo-form-inline toolbar"
          @submit.native.prevent
        >
          <el-form-item label="老人姓名">
            <el-input
              clearable
              v-model.trim="formInline.elderlyName"
              placeholder="请输入老人姓名"
              style="width: 140px;"
              @keyup.enter.native.prevent="enterSearch"
            ></el-input>
          </el-form-item>
          <el-form-item label="身份证号">
            <el-input
              clearable
              v-model.trim="formInline.idCard"
              placeholder="请输入身份证号"
              style="width: 180px;"
              @keyup.enter.native.prevent="enterSearch"
            ></el-input>
          </el-form-item>
          <el-form-item label="申请状态">
            <el-select
              v-model="formInline.applyStatus"
              style="width: 140px"
              clearable
            >
              <el-option value="" label="全部"></el-option>
              <el-option value="1" label="正常入托"></el-option>
              <el-option value="2" label="申请退托"></el-option>
              <el-option value="3" label="已退托"></el-option>
            </el-select>
          </el-form-item>
          <el-form-item label="审核状态">
            <el-select
              v-model="formInline.auditStatus"
              style="width: 140px"
              clearable
            >
              <el-option value="" label="全部"></el-option>
              <el-option value="0" label="未审核"></el-option>
              <el-option value="1" label="审核通过"></el-option>
              <el-option value="2" label="审核拒绝"></el-option>
            </el-select>
          </el-form-item>
          <el-form-item>
            <el-button
              type="primary"
              icon="el-icon-search"
              @click="search"
              plain
              >查询</el-button
            >
            <el-button
              type="success"
              icon="el-icon-plus"
              @click="addApply"
              plain
              >新增入托申请</el-button
            >
            <el-button
              type="info"
              @click="downTemplate"
              icon="el-icon-document"
              plain
              >申请模板下载</el-button
            >
            <el-button
              type="info"
              @click="toImport"
              icon="el-icon-upload"
              plain
              style="margin-left: 10px"
              >批量导入</el-button
            >
            <el-button
              type="info"
              @click="downReport"
              icon="el-icon-download"
              plain
              style="margin-left: 10px"
              >申请报表导出</el-button
            >
          </el-form-item>
        </el-form>

        <!-- 申请列表表格 -->
        <el-table
          style="width: 100%"
          :data="tableData"
          v-loading="tableLoading"
          ref="multipleTable"
          :header-cell-style="{
            'text-align': 'center',
            'font-size': '16px',
            'font-weight': '600',
            color: '#2d2d2d',
            'background-color': '#d4f5fa',
          }"
          :cell-style="{ 'text-align': 'center', 'font-size': '16px' }"
          :row-style="tableRowStyle"
        >
          <el-table-column
            prop="elderlyName"
            label="老人姓名"
            min-width="100"
          ></el-table-column>
          <el-table-column
            prop="idCard"
            label="身份证号"
            min-width="180"
          ></el-table-column>
          <el-table-column
            prop="elderlySex"
            label="性别"
            min-width="50"
            :formatter="formatSex"
          ></el-table-column>
          <el-table-column
            prop="familyName"
            label="家属姓名"
            min-width="100"
          ></el-table-column>
          <el-table-column
            prop="familyPhone"
            label="家属联系电话"
            min-width="120"
          ></el-table-column>
          <el-table-column
            prop="bedType"
            label="床位类型"
            min-width="100"
            :formatter="formatBedType"
          ></el-table-column>
          <el-table-column
            prop="applyType"
            label="申请类型"
            min-width="100"
            :formatter="formatApplyType"
          ></el-table-column>
          <el-table-column
            prop="applyStatus"
            label="申请状态"
            min-width="100"
            :formatter="formatApplyStatus"
          ></el-table-column>
          <el-table-column
            prop="auditStatus"
            label="审核状态"
            min-width="100"
            :formatter="formatAuditStatus"
          ></el-table-column>
          <el-table-column
            prop="createTime"
            label="申请时间"
            min-width="140"
          ></el-table-column>
          <el-table-column
            prop="creatorName"
            label="申请人"
            min-width="100"
          ></el-table-column>
          <el-table-column label="操作" min-width="230">
            <template slot-scope="scope">
              <el-button
                type="primary"
                size="mini"
                plain
                @click="handleAudit(scope.row)"
                v-if="scope.row.auditStatus === 0"
                >审核</el-button>
              <el-button
                style="margin-left: 2px"
                type="warning"
                size="mini"
                plain
                @click="handleQuit(scope.row)"
                v-if="scope.row.applyStatus === 1"
                >申请退托</el-button>
              <el-button
                style="margin-left: 2px"
                type="info"
                size="mini"
                plain
                @click="handleEdit(scope.row)"
                >编辑</el-button>
            </template>
          </el-table-column>
        </el-table>

        <!-- 分页组件 -->
        <el-pagination
          background
          @size-change="handleSizeChange"
          @current-change="handleCurrentChange"
          :current-page="currentPage"
          layout="total, prev, pager, next"
          :total="totalDataNumber"
          :page-size="pageSize"
          align="center"
          class="fenye"
        >
        </el-pagination>
      </el-row>

      <!-- 新增/编辑入托申请弹窗 -->
      <el-dialog
        :title="isEdit ? '编辑入托申请' : '新增入托申请'"
        width="60%"
        :visible.sync="formVisible"
        :close-on-click-modal="false"
        :close-on-press-escape="false"
      >
        <el-form ref="applyForm" :model="applyForm" :rules="formRules" label-width="120px">
          <el-row :gutter="20">
            <el-col :span="12">
              <el-form-item label="老人姓名" prop="elderlyName">
                <el-input v-model="applyForm.elderlyName" placeholder="请输入老人姓名"></el-input>
              </el-form-item>
            </el-col>
            <el-col :span="12">
              <el-form-item label="性别" prop="elderlySex">
                <el-select v-model="applyForm.elderlySex" placeholder="请选择性别">
                  <el-option value="0" label="男"></el-option>
                  <el-option value="1" label="女"></el-option>
                </el-select>
              </el-form-item>
            </el-col>
            <el-col :span="12">
              <el-form-item label="出生日期" prop="birthday">
                <el-date-picker
                  v-model="applyForm.birthday"
                  type="date"
                  placeholder="选择出生日期"
                  value-format="yyyy-MM-dd"
                ></el-date-picker>
              </el-form-item>
            </el-col>
            <el-col :span="12">
              <el-form-item label="身份证号" prop="idCard">
                <el-input v-model="applyForm.idCard" placeholder="请输入身份证号"></el-input>
              </el-form-item>
            </el-col>
            <el-col :span="12">
              <el-form-item label="家属姓名" prop="familyName">
                <el-input v-model="applyForm.familyName" placeholder="请输入家属姓名"></el-input>
              </el-form-item>
            </el-col>
            <el-col :span="12">
              <el-form-item label="家属联系电话" prop="familyPhone">
                <el-input v-model="applyForm.familyPhone" placeholder="请输入家属联系电话"></el-input>
              </el-form-item>
            </el-col>
            <el-col :span="12">
              <el-form-item label="与老人关系" prop="relationship">
                <el-select v-model="applyForm.relationship" placeholder="请选择关系">
                  <el-option value="1" label="子女"></el-option>
                  <el-option value="2" label="配偶"></el-option>
                  <el-option value="3" label="父母"></el-option>
                  <el-option value="4" label="兄弟姐妹"></el-option>
                  <el-option value="5" label="其他"></el-option>
                </el-select>
              </el-form-item>
            </el-col>
            <el-col :span="12">
              <el-form-item label="申请类型" prop="applyType">
                <el-select v-model="applyForm.applyType" placeholder="请选择申请类型">
                  <el-option value="1" label="短期入托"></el-option>
                  <el-option value="2" label="长期入托"></el-option>
                </el-select>
              </el-form-item>
            </el-col>
            <el-col :span="12">
              <el-form-item label="意向床位类型" prop="bedType">
                <el-select v-model="applyForm.bedType" placeholder="请选择床位类型">
                  <el-option value="1" label="单人间"></el-option>
                  <el-option value="2" label="双人间"></el-option>
                  <el-option value="3" label="多人间"></el-option>
                </el-select>
              </el-form-item>
            </el-col>
            <el-col :span="12">
              <el-form-item label="申请入托时间">
                <el-date-picker
                  v-model="applyForm.applyCheckInTime"
                  type="date"
                  placeholder="选择申请入托时间"
                  value-format="yyyy-MM-dd"
                ></el-date-picker>
              </el-form-item>
            </el-col>
            <el-col :span="24">
              <el-form-item label="健康状况描述">
                <el-input v-model="applyForm.healthCondition" type="textarea" :rows="3" placeholder="请简要描述老人健康状况"></el-input>
              </el-form-item>
            </el-col>
            <el-col :span="24">
              <el-form-item label="特殊需求说明">
                <el-input v-model="applyForm.specialNeeds" type="textarea" :rows="2" placeholder="如有特殊护理需求请说明"></el-input>
              </el-form-item>
            </el-col>
          </el-row>
        </el-form>
        <div slot="footer" class="dialog-footer" align="center">
          <el-button @click="formVisible = false">取消</el-button>
          <el-button type="primary" @click="submitForm">确定</el-button>
        </div>
      </el-dialog>

      <!-- 审核弹窗 -->
      <el-dialog
        title="入托申请审核"
        width="40%"
        :visible.sync="auditVisible"
        :close-on-click-modal="false"
        :close-on-press-escape="false"
      >
        <el-form ref="auditForm" :model="auditForm" :rules="auditRules" label-width="100px">
          <el-form-item label="审核结果" prop="auditStatus">
            <el-select v-model="auditForm.auditStatus" placeholder="请选择审核结果">
              <el-option value="1" label="审核通过"></el-option>
              <el-option value="2" label="审核拒绝"></el-option>
            </el-select>
          </el-form-item>
          <el-form-item label="审核意见" prop="auditRemark">
            <el-input v-model="auditForm.auditRemark" type="textarea" :rows="4" placeholder="请输入审核意见"></el-input>
          </el-form-item>
        </el-form>
        <div slot="footer" class="dialog-footer" align="center">
          <el-button @click="auditVisible = false">取消</el-button>
          <el-button type="primary" @click="submitAudit">提交审核</el-button>
        </div>
      </el-dialog>

      <!-- 退托申请弹窗 -->
      <el-dialog
        title="退托申请"
        width="40%"
        :visible.sync="quitVisible"
        :close-on-click-modal="false"
        :close-on-press-escape="false"
      >
        <el-form ref="quitForm" :model="quitForm" :rules="quitRules" label-width="110px">
          <el-form-item label="申请退托时间" prop="applyCheckOutTime">
            <el-date-picker
              v-model="quitForm.applyCheckOutTime"
              type="date"
              placeholder="选择申请退托时间"
              value-format="yyyy-MM-dd"
            ></el-date-picker>
          </el-form-item>
          <el-form-item label="退托原因" prop="quitReason">
            <el-input v-model="quitForm.quitReason" type="textarea" :rows="4" placeholder="请输入退托原因"></el-input>
          </el-form-item>
        </el-form>
        <div slot="footer" class="dialog-footer" align="center">
          <el-button @click="quitVisible = false">取消</el-button>
          <el-button type="primary" @click="submitQuit">提交退托申请</el-button>
        </div>
      </el-dialog>

      <!-- 批量导入弹窗 -->
      <el-dialog
        title="批量导入入托申请"
        width="30%"
        :visible.sync="importVisible"
        :close-on-click-modal="false"
        @close="importCloseDialog"
      >
        <el-row type="flex" justify="center">
          <el-col :span="20">
            <el-row>
              <el-col :span="24">
                <input type="file" ref="importFile" id="importFile" @change="handleFileChange" accept=".xlsx,.xls" />
                <div style="margin-top: 10px; color: #666; font-size: 14px;">支持格式：.xlsx、.xls，请下载模板并按格式填写</div>
              </el-col>
            </el-row>
          </el-col>
        </el-row>
        <div slot="footer" class="dialog-footer" align="center">
          <el-button @click.native="importVisible = false">取消</el-button>
          <el-button type="primary" @click.native="submitImport">确定导入</el-button>
        </div>
      </el-dialog>

      <!-- 报表导出字段选择弹窗 -->
      <el-dialog
        title="导出字段选择"
        width="420px"
        :visible.sync="fieldsVisible"
        :close-on-click-modal="false"
        :close-on-press-escape="false"
        @close="closeFieldsDialog"
      >
        <el-checkbox
          :indeterminate="isIndeterminate"
          v-model="checkAll"
          @change="handleCheckAllChange"
          >全选</el-checkbox
        >
        <div style="margin: 15px 0"></div>
        <el-checkbox-group
          v-model="selectedFields"
          @change="handleCheckedFieldsChange"
          style="display: flex; flex-wrap: wrap; width: 100%"
        >
          <el-checkbox
            v-for="item in exportFields"
            :label="item.value"
            :key="item.value"
            size="            medium"
            :disabled="item.required"
            style="width: 42%"
            >{{ item.label }}</el-checkbox
          >
        </el-checkbox-group>
        <div slot="footer" class="dialog-footer" align="center">
          <el-button @click="fieldsVisible = false">取消</el-button>
          <el-button type="primary" @click="confirmExport">确认导出</el-button>
        </div>
      </el-dialog>
    </div>
  </div>
</template>

<script>
import bus from "@/vuex/eventBus";
import { baseURL } from "@/utils/request.js";

export default {
  name: "ElderlyNursingList",
  data() {
    return {
      // 查询表单
      formInline: {
        elderlyName: "",
        idCard: "",
        applyStatus: "",
        auditStatus: ""
      },
      // 表格数据
      tableData: [],
      tableLoading: false,
      // 分页参数
      currentPage: 1,
      pageNo: 1,
      pageSize: 10,
      totalDataNumber: 0,

      // 弹窗控制
      formVisible: false, // 新增/编辑弹窗
      auditVisible: false, // 审核弹窗
      quitVisible: false, // 退托申请弹窗
      importVisible: false, // 批量导入弹窗
      fieldsVisible: false, // 导出字段选择弹窗

      // 表单数据
      isEdit: false,
      applyForm: {
        id: null,
        elderlyName: "",
        elderlySex: null,
        birthday: "",
        idCard: "",
        familyName: "",
        familyPhone: "",
        relationship: null,
        applyType: null,
        bedType: null,
        applyCheckInTime: "",
        healthCondition: "",
        specialNeeds: ""
      },
      auditForm: {
        applyId: null,
        auditStatus: null,
        auditRemark: ""
      },
      quitForm: {
        applyId: null,
        applyCheckOutTime: "",
        quitReason: ""
      },

      // 表单验证规则
      formRules: {
        elderlyName: [
          { required: true, message: "请输入老人姓名", trigger: "blur" }
        ],
        elderlySex: [
          { required: true, message: "请选择性别", trigger: "change" }
        ],
        birthday: [
          { required: true, message: "请选择出生日期", trigger: "change" }
        ],
        idCard: [
          { required: true, message: "请输入身份证号", trigger: "blur" }
        ],
        familyName: [
          { required: true, message: "请输入家属姓名", trigger: "blur" }
        ],
        familyPhone: [
          { required: true, message: "请输入家属联系电话", trigger: "blur" }
        ],
        relationship: [
          { required: true, message: "请选择与老人关系", trigger: "change" }
        ],
        applyType: [
          { required: true, message: "请选择申请类型", trigger: "change" }
        ],
        bedType: [
          { required: true, message: "请选择意向床位类型", trigger: "change" }
        ]
      },
      auditRules: {
        auditStatus: [
          { required: true, message: "请选择审核结果", trigger: "change" }
        ],
        auditRemark: [
          { required: true, message: "请输入审核意见", trigger: "blur" }
        ]
      },
      quitRules: {
        applyCheckOutTime: [
          { required: true, message: "请选择申请退托时间", trigger: "change" }
        ],
        quitReason: [
          { required: true, message: "请输入退托原因", trigger: "blur" }
        ]
      },

      // 导出字段配置
      exportFields: [
        { value: "elderlyName", label: "老人姓名", required: true },
        { value: "idCard", label: "身份证号", required: true },
        { value: "elderlySex", label: "性别", required: true },
        { value: "birthday", label: "出生日期" },
        { value: "familyName", label: "家属姓名" },
        { value: "familyPhone", label: "家属电话" },
        { value: "applyType", label: "申请类型" },
        { value: "bedType", label: "床位类型" },
        { value: "applyStatus", label: "申请状态" },
        { value: "auditStatus", label: "审核状态" },
        { value: "createTime", label: "申请时间" }
      ],
      selectedFields: ["elderlyName", "idCard", "elderlySex"],
      checkAll: false,
      isIndeterminate: true,

      // 导入文件相关
      importFile: null,
      fileFlag: false
    };
  },

  methods: {
    // 表格行样式
    tableRowStyle({ row, rowIndex }) {
      return rowIndex % 2 === 0 
        ? { "background-color": "#ffffff" } 
        : { "background-color": "#e4f5f8" };
    },

    // 格式化性别
    formatSex(row) {
      return row.elderlySex === 0 ? "男" : "女";
    },

    // 格式化床位类型
    formatBedType(row) {
      const bedTypes = { 1: "单人间", 2: "双人间", 3: "多人间" };
      return bedTypes[row.bedType] || "未知";
    },

    // 格式化申请类型
    formatApplyType(row) {
      return row.applyType === 1 ? "短期入托" : "长期入托";
    },

    // 格式化申请状态
    formatApplyStatus(row) {
      const statusMap = { 1: "正常入托", 2: "申请退托", 3: "已退托" };
      return statusMap[row.applyStatus] || "未知";
    },

    // 格式化审核状态
    formatAuditStatus(row) {
      const auditMap = { 0: "未审核", 1: "审核通过", 2: "审核拒绝" };
      return auditMap[row.auditStatus] || "未知";
    },

    // 搜索
    search() {
      this.pageNo = 1;
      this.queryNursingList();
    },

    // 回车搜索
    enterSearch() {
      this.search();
    },

    // 分页大小变更
    handleSizeChange(val) {
      this.pageSize = val;
      this.queryNursingList();
    },

    // 当前页变更
    handleCurrentChange(val) {
      this.pageNo = val;
      this.queryNursingList();
    },

    // 查询入托申请列表
    queryNursingList() {
      this.tableLoading = true;
      const params = {
        ...this.formInline,
        pageNo: this.pageNo,
        pageSize: this.pageSize,
        groupId: sessionStorage.getItem("groupId")
      };

      this.$postJson("omc/elderlyNursing/queryListWithPage", params).then(res => {
        this.tableLoading = false;
        if (res.code === 200) {
          this.tableData = res.result.list || [];
          this.totalDataNumber = Number(res.result.total) || 0;
          this.currentPage = res.result.pageNum || 1;
        } else {
          this.$message.error(res.message || "查询失败");
          this.tableData = [];
          this.totalDataNumber = 0;
        }
      }).catch(() => {
        this.tableLoading = false;
        this.tableData = [];
        this.totalDataNumber = 0;
      });
    },

    // 新增申请
    addApply() {
      this.isEdit = false;
      this.applyForm = {
        id: null,
        elderlyName: "",
        elderlySex: null,
        birthday: "",
        idCard: "",
        familyName: "",
        familyPhone: "",
        relationship: null,
        applyType: null,
        bedType: null,
        applyCheckInTime: "",
        healthCondition: "",
        specialNeeds: ""
      };
      this.formVisible = true;
    },

    // 编辑申请
    handleEdit(row) {
      this.isEdit = true;
      this.applyForm = { ...row };
      this.formVisible = true;
    },

    // 提交表单（新增/编辑）
    submitForm() {
      this.$refs.applyForm.validate(valid => {
        if (valid) {
          const url = this.isEdit 
            ? "omc/elderlyNursing/update" 
            : "omc/elderlyNursing/add";
          
          this.$postJson(url, {
            ...this.applyForm,
            groupId: sessionStorage.getItem("groupId")
          }).then(res => {
            if (res.code === 200) {
              this.$message.success(this.isEdit ? "编辑成功" : "新增成功");
              this.formVisible = false;
              this.queryNursingList();
            } else {
              this.$message.error(res.message || "操作失败");
            }
          });
        }
      });
    },

    // 审核申请
    handleAudit(row) {
      this.auditForm = {
        applyId: row.id,
        auditStatus: null,
        auditRemark: ""
      };
      this.auditVisible = true;
    },

    // 提交审核
    submitAudit() {
      this.$refs.auditForm.validate(valid => {
        if (valid) {
          this.$postJson("omc/elderlyNursing/audit", {
            ...this.auditForm,
            groupId: sessionStorage.getItem("groupId"),
            auditorId: sessionStorage.getItem("userId"),
            auditorName: sessionStorage.getItem("userName")
          }).then(res => {
            if (res.code === 200) {
              this.$message.success("审核成功");
              this.auditVisible = false;
              this.queryNursingList();
            } else {
              this.$message.error(res.message || "审核失败");
            }
          });
        }
      });
    },

    // 退托申请
    handleQuit(row) {
      this.quitForm = {
        applyId: row.id,
        applyCheckOutTime: "",
        quitReason: ""
      };
      this.quitVisible = true;
    },

    // 提交退托申请
    submitQuit() {
      this.$refs.quitForm.validate(valid => {
        if (valid) {
          this.$postJson("omc/elderlyNursing/applyQuit", {
            id: this.quitForm.applyId,
            applyCheckOutTime: this.quitForm.applyCheckOutTime,
            remark: this.quitForm.quitReason,
            applyStatus: 2, // 申请退托状态
            groupId: sessionStorage.getItem("groupId")
          }).then(res => {
            if (res.code === 200) {
              this.$message.success("退托申请提交成功");
              this.quitVisible = false;
              this.queryNursingList();
            } else {
              this.$message.error(res.message || "提交失败");
            }
          });
        }
      });
    },

    // 查看详情
    handleDetail(row) {
      sessionStorage.setItem("nursingId", row.id);
      bus.$emit("homePage", {
        type: "jump",
        path: "/ElderlyNursingDetail",
        title: "入托申请详情"
      });
    },

    // 模板下载
    downTemplate() {
      window.location.href = `${baseURL}omc/elderlyNursing/downTemplate?groupId=${sessionStorage.getItem("groupId")}`;
    },

    // 批量导入
    toImport() {
      this.importVisible = true;
      this.importFile = null;
      this.fileFlag = false;
      this.$refs.importFile.value = "";
    },

    // 处理文件选择
    handleFileChange(event) {
      const file = event.target.files[0];
      if (file) {
        this.importFile = file;
        this.fileFlag = true;
      }
    },

    // 关闭导入弹窗
    importCloseDialog() {
      this.$refs.importFile.value = "";
    },

    // 提交导入
    submitImport() {
      if (!this.fileFlag) {
        this.$message.error("请选择导入文件");
        return;
      }

      const formData = new FormData();
      formData.append("file", this.importFile);
      formData.append("groupId", sessionStorage.getItem("groupId"));

      this.$postFormData("omc/elderlyNursing/import", formData).then(res => {
        this.importVisible = false;
        if (res.code === 200) {
          this.$message.success("导入成功");
          this.queryNursingList();
        } else {
          this.$message.error(res.message || "导入失败");
        }
      });
    },

    // 报表导出
    downReport() {
      this.fieldsVisible = true;
    },

    // 全选处理
    handleCheckAllChange(val) {
      this.selectedFields = val 
        ? this.exportFields.map(item => item.value) 
        : this.exportFields.filter(item => item.required).map(item => item.value);
      this.isIndeterminate = false;
    },

    // 字段选择变化
    handleCheckedFieldsChange(value) {
      const requiredLength = this.exportFields.filter(item => item.required).length;
      this.checkAll = value.length === this.exportFields.length;
      this.isIndeterminate = value.length > requiredLength && value.length < this.exportFields.length;
    },

    // 关闭字段选择弹窗
    closeFieldsDialog() {
      const requiredFields = this.exportFields.filter(item => item.required).map(item => item.value);
      this.selectedFields = [...new Set([...requiredFields, ...this.selectedFields])];
    },

    // 确认导出
    confirmExport() {
      const params = new URLSearchParams();
      params.append("groupId", sessionStorage.getItem("groupId"));
      params.append("fields", this.selectedFields.join(","));
      Object.entries(this.formInline).forEach(([key, val]) => {
        if (val) params.append(key, val);
      });

      window.location.href = `${baseURL}omc/elderlyNursing/export?${params.toString()}`;
      this.fieldsVisible = false;
    }
  },

  mounted() {
    this.queryNursingList();
    // 监听详情页返回刷新
    this.$bus.$on("refreshNursingList", () => {
      this.queryNursingList();
    });
  },

  beforeDestroy() {
    this.$bus.$off("refreshNursingList");
  }
};
</script>

<style lang="scss" scoped>
.toolbar {
  padding: 10px 0 10px 10px;
  background: #fff;
  border-radius: 4px 4px 0 0;
}

.fenye {
  padding: 20px 0;
  background: #fff;
  border-radius: 0 0 4px 4px;
}

::v-deep .el-dialog__header {
  padding: 15px 20px;
  border-bottom: 1px solid #eee;
}

::v-deep .el-dialog__footer {
  padding: 15px 20px;
  border-top: 1px solid #eee;
}

::v-deep .el-form-item {
  margin-bottom: 15px;
}
</style>